import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=8959885a&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=js&"
export * from "./UserMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=8959885a&prod&lang=less&scoped=true&"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=8959885a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8959885a",
  null
  
)

export default component.exports